/*
  Grifos · botón "Añadir" de los complementos compatibles (snippets/grifos-complementos.liquid), en la ficha y
  en el carrito lateral. Añade el accesorio sin salir de la página y avisa al tema como lo hace su propio
  formulario de compra (evento "shopify:cart:lines-update"): el carrito lateral se refresca y se abre, y el
  número del icono del carrito se actualiza. En la página del carrito el formulario va sin data-type y se
  envía normal (/cart/add vuelve a /cart con el accesorio).
*/
import { CartLinesUpdateEvent } from '@shopify/events';
import { fetchConfig } from '@theme/utilities';

if (!window.grifosComplementos) {
  window.grifosComplementos = true;

  document.addEventListener('submit', async (evento) => {
    const form = evento.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.grifos-complemento__form[data-type="add-to-cart-form"]')) return;
    evento.preventDefault();

    const boton = form.querySelector('[type="submit"]');
    if (boton?.getAttribute('aria-busy') === 'true') return;
    boton?.setAttribute('aria-busy', 'true');

    const datos = new FormData(form);
    datos.set('quantity', '1');
    const secciones = [...document.querySelectorAll('cart-items-component')]
      .map((caja) => caja instanceof HTMLElement && caja.dataset.sectionId)
      .filter(Boolean);
    if (secciones.length) datos.append('sections', secciones.join(','));

    const aviso = CartLinesUpdateEvent.createPromise();
    form.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: /** @type {string} */ (datos.get('id')), quantity: 1 }],
        promise: aviso.promise,
      })
    );

    try {
      const cfg = fetchConfig('javascript', { body: datos });
      const respuesta = await fetch(Theme.routes.cart_add_url, {
        ...cfg,
        headers: { ...cfg.headers, Accept: 'text/html' },
      }).then((r) => r.json());
      if (respuesta.status) throw new Error(respuesta.message || 'No se pudo añadir');

      const carrito = await fetch(`${Theme.routes.cart_url}.js`).then((r) => r.json());
      aviso.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(carrito),
        detail: {
          items: carrito.items,
          source: 'grifos-complementos',
          sourceId: form.id,
          itemCount: 1,
          sections: respuesta.sections,
          didError: false,
        },
      });
      boton?.classList.add('grifos-complemento__boton--hecho');
      setTimeout(() => boton?.classList.remove('grifos-complemento__boton--hecho'), 2000);
    } catch (error) {
      aviso.reject(error);
      // Sin JavaScript de por medio: el envío normal deja el accesorio en el carrito y lleva a /cart
      form.removeAttribute('data-type');
      form.submit();
    } finally {
      boton?.removeAttribute('aria-busy');
    }
  });
}
